import { authorizedFetch as fetch } from '@/helpers/authFetch';
import CodeError from '@/helpers/CodeError';

const RETRY_INTERVAL_MILIS = 1000;
const ERROR_STATUS_CODE = 409;
const NOT_READY = 'not_ready';

// TODO Revisar esto para mostrar un mensaje si no se obtienen los datos del mensaje
const retryCampaignRequest = async (url, options) => {
  let myTimeout;
  const delay = (MILIS) => new Promise((resolve) => { myTimeout = setTimeout(resolve, MILIS); });
  let retried = 0;
  const MAX_TAB_RETRY = 50;
  const baseRequest = async () => {
    const response = await fetch(url, options);

    if (response.ok) {
      clearTimeout(myTimeout);

      return response.json();
    }

    const responseJson = await response.json();

    if (response.status === ERROR_STATUS_CODE && responseJson.errorCode.endsWith(NOT_READY)) {
      clearTimeout(myTimeout);

      if (retried >= MAX_TAB_RETRY) {
        console.error('Campaign description failed. Unable to recover');
        throw new CodeError('Max retries reached', responseJson.errorCode, response.status);
      }

      retried += 1;
      console.error(`Campaign description failed. Retry ${retried}/${MAX_TAB_RETRY}`);

      await delay(RETRY_INTERVAL_MILIS);
      return await baseRequest();
    }

    throw new CodeError(response.statusText, responseJson.errorCode, response.status);
  };

  return baseRequest();
};

export default retryCampaignRequest;
